/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
/* eslint-disable security/detect-unsafe-regex */

import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import moment from 'moment';
import { getCurrentCountry } from './domain';

export const validateEmail = (email) =>
  String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

export const isValidHttpUrl = (string) => {
  const pattern =
    /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{0,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

  return pattern.test(string);
};

export const validateIPaddress = (ipaddress) => {
  if (
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      ipaddress,
    )
  ) {
    return true;
  }
  return false;
};

export const validatePhoneNumber = (phoneCode, phoneNumber) => {
  // get current country
  const country = getCurrentCountry();

  // phone number start with 0 eg: 0987654321
  if (phoneNumber.match(/^0/)) {
    return false;
  }

  // check phone number length for country br
  if (country === 'br' && ![10, 11].includes(phoneNumber.length)) {
    return false;
  }

  const phone = parsePhoneNumberFromString(`+${phoneCode}${phoneNumber}`);
  return phone && phone.isPossible();
};

export const validateScheduleCampaignTime = (dateTime) => {
  if (!dateTime || dateTime.isBefore(moment())) {
    return false;
  }

  return true;
};
